import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import * as Types from '../../../../types/api.types.generated.d';

const defaultOptions = {} as const;
export type UnviewedApplicationCountQueryVariables = Types.Exact<{ [key: string]: never }>;

export type UnviewedApplicationCountQuery = {
  __typename?: 'Query';
  unviewedApplicationCount: number;
};

export const UnviewedApplicationCountDocument = gql`
  query unviewedApplicationCount {
    unviewedApplicationCount
  }
`;

/**
 * __useUnviewedApplicationCountQuery__
 *
 * To run a query within a React component, call `useUnviewedApplicationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnviewedApplicationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnviewedApplicationCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnviewedApplicationCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UnviewedApplicationCountQuery,
    UnviewedApplicationCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UnviewedApplicationCountQuery, UnviewedApplicationCountQueryVariables>(
    UnviewedApplicationCountDocument,
    options,
  );
}
export function useUnviewedApplicationCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UnviewedApplicationCountQuery,
    UnviewedApplicationCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UnviewedApplicationCountQuery, UnviewedApplicationCountQueryVariables>(
    UnviewedApplicationCountDocument,
    options,
  );
}
export function useUnviewedApplicationCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UnviewedApplicationCountQuery,
        UnviewedApplicationCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    UnviewedApplicationCountQuery,
    UnviewedApplicationCountQueryVariables
  >(UnviewedApplicationCountDocument, options);
}
export type UnviewedApplicationCountQueryHookResult = ReturnType<
  typeof useUnviewedApplicationCountQuery
>;
export type UnviewedApplicationCountLazyQueryHookResult = ReturnType<
  typeof useUnviewedApplicationCountLazyQuery
>;
export type UnviewedApplicationCountSuspenseQueryHookResult = ReturnType<
  typeof useUnviewedApplicationCountSuspenseQuery
>;
export type UnviewedApplicationCountQueryResult = Apollo.QueryResult<
  UnviewedApplicationCountQuery,
  UnviewedApplicationCountQueryVariables
>;
export function refetchUnviewedApplicationCountQuery(
  variables?: UnviewedApplicationCountQueryVariables,
) {
  return { query: UnviewedApplicationCountDocument, variables };
}
